import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const featuredArticle = articles[0];
  const gridArticles = articles.slice(1, 9);

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-12 mb-12">
          <div className="md:w-[380px] flex-shrink-0">
            <h2
              className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              热门大瓜
              <br />
              不容错过
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md pt-2">
            全网最热爆料帖汇总，实时更新最新大瓜。点击查看完整爆料内容，
            精彩不容错过。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {/* Featured Large Card */}
          <Link
            to={`/article/${featuredArticle.id}`}
            className="group block lg:col-span-1 lg:row-span-2 rounded-xl overflow-hidden relative cursor-pointer"
          >
            <div className="relative h-full min-h-[400px]">
              <img
                src={featuredArticle.coverImage}
                alt={featuredArticle.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-full mb-3">
                  {featuredArticle.category}
                </span>
                <h3 className="text-background-50 font-bold text-lg md:text-xl leading-snug mb-2 line-clamp-3">
                  {featuredArticle.title}
                </h3>
                <p className="text-background-200 text-sm line-clamp-2 mb-3">{featuredArticle.excerpt}</p>
                <div className="flex items-center gap-3 text-background-300 text-xs">
                  <span><i className="ri-eye-line mr-1"></i>{(featuredArticle.viewCount / 10000).toFixed(1)}万阅读</span>
                  <span>{featuredArticle.publishDate}</span>
                </div>
              </div>
            </div>
          </Link>

          {/* Regular Cards */}
          {gridArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-accent-500/90 text-background-50 text-xs rounded-full">
                  {article.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-foreground-900 font-medium text-sm md:text-base leading-snug line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-foreground-500 text-xs">
                  <span><i className="ri-eye-line mr-1"></i>{(article.viewCount / 10000).toFixed(1)}万</span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Button */}
        <div className="flex justify-center mt-10">
          <Link
            to="/category/remen-baoliao"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}